import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFlipHorizontalCircle16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconFlipHorizontalCircle16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M3.984 9.801a4.401 4.401 0 0 0 8.03 0h1.288a5.6 5.6 0 0 1-5.303 3.8 5.6 5.6 0 0 1-5.303-3.8zM14.601 7.41a.6.6 0 0 1 0 1.199H1.399a.6.6 0 0 1 0-1.2zm-6.314-5a5.6 5.6 0 0 1 5.015 3.79h-1.288a4.4 4.4 0 0 0-8.03 0H2.696C3.446 3.99 5.536 2.4 8 2.4z"
            />
        </svg>
    );
}
export default memo(IconFlipHorizontalCircle16);
